module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "itemtransparent "
    }), _vm._v(" "), _c('div', {
      staticClass: "itemtransparent "
    }), _vm._v(" "), _c('div', {
      staticClass: "itemtransparent"
    }, [_vm._v(_vm._s(item.regionName))]), _vm._v(" "), _c('div', {
      staticClass: "itemtransparent"
    }, [_vm._v(_vm._s(item.amount))])])
  }), 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item list-item1"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("待迁移数据")]), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("已迁移数据")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("迁移数据记录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("蔬菜溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("小麦溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("数据名称")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("耗时/ms")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("生鲜乳检测数据")]), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("甜菜溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("水果溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("生猪溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("牛肉溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("羊肉溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("禽肉溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("牛奶溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item right"
  }, [_vm._v("蘑菇溯源数据")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62ab061d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/test/components/table/index.vue
// module id = 2021
// module chunks = 2